import React from 'react'
import { motion, HTMLMotionProps } from 'framer-motion'

const transition = { duration: 0.6, ease: [ 0.43, 0.13, 0.23, 0.96 ] }

type Props = HTMLMotionProps<'img'>

export default function Image({ src, alt, ...rest }: Props ) {
	// Shopify tries to hack alt code to add floats — doesn't work as React will
	// char encode this `&quot; style=&quot;float: none;` sillyness
	if ( alt?.charAt( 0 ) === '"' ) alt = ''

	return (
		<motion.img
			src={res( src )}
			srcSet={srcSet( src, [ 350, 585, 800, 1000, 1170, 1500, 2500 ] )}
			alt={alt || ''}
			transition={transition}
			{...rest}
		/>
	)
}

export const res = ( src, options = null ) => (
	src.replace(
		/.*(https:\/\/cdn.shopify.com\/.+)(\.[a-z]{3,4}[?=&a-zA-Z0-9]*).*/,
		`$1${( options ? `_${options}` : '' )}$2`
	)
)

const srcSet = ( src, widths ) => (
	widths.map( width => (
		`${res( src, `${width}x` )} ${width}w`
	) ).join( ',' )
)
